import { render, staticRenderFns } from "./CartPageItem.vue?vue&type=template&id=8c50df30&"
import script from "./CartPageItem.vue?vue&type=script&lang=js&"
export * from "./CartPageItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports